export const PHONE_DISPLAY = "(270) 743-7860";
export const PHONE_TEL = "+12707437860";
export const EMAIL = "Rockinhweld@gmail.com";
export const GBP_URL = "https://www.google.com/maps/search/?api=1&query=Rockin+H+Welding+Firebaugh+CA";

export const SERVICES = [
  {
    id: "fabrication",
    title: "Custom Fabrication",
    titleEs: "Fabricación a Medida",
    blurb:
      "Trailers, racks, brackets, bumpers, frames. You bring the idea or the broken part — Wade builds it out of steel that outlives the job.",
    blurbEs:
      "Remolques, racks, soportes, defensas y armazones. Traiga la idea o la pieza rota — Wade la hace de acero que dura más que el trabajo.",
    image:
      "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-2",
  },
  {
    id: "gates",
    title: "Gates & Fencing",
    titleEs: "Portones y Cercas",
    blurb:
      "Ranch entries, driveway gates, corral panels, pipe fence and ornamental handrails. Hung square, latched right, built to swing for decades.",
    blurbEs:
      "Entradas de rancho, portones de cochera, paneles de corral, cerca de tubo y barandales ornamentales. Bien nivelados, bien cerrados, hechos para durar décadas.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_firebaugh-metal-shop-1/artifacts/nemnnvka_IMG_4990.webp",
    span: "",
  },
  {
    id: "repair",
    title: "General Farm Repair",
    titleEs: "Reparación Agrícola",
    blurb: "Cracked implements, busted hitches, worn buckets. Shop work or on-site with the rig — whatever gets you back in the field faster.",
    blurbEs:
      "Implementos quebrados, enganches rotos, cucharas gastadas. En el taller o a domicilio con la soldadora — lo que lo regrese al campo más rápido.",
    image:
      "https://images.unsplash.com/photo-1531798123643-26d5ab4c264d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "",
  },
  {
    id: "smokers",
    title: "Restored BBQ Smokers",
    titleEs: "Asadores BBQ Restaurados",
    blurb:
      "Old tanks and tired pits brought back to life. Reverse-flow builds, trailer mounts, fresh doors, gauges and grates. Cooks clean, hauls easy.",
    blurbEs:
      "Tanques viejos y asadores cansados vueltos a la vida. Flujo invertido, montaje en remolque, puertas nuevas, termómetros y parrillas. Cocina limpio y se jala fácil.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_firebaugh-metal-shop-1/artifacts/ahgzafo4_IMG_3535.webp",
    span: "lg:col-span-2",
    featured: true,
  },
  {
    id: "other",
    title: "Much, Much More",
    blurb: "Metal art, signs, sculptures, one-offs and the stuff nobody else wants to touch. If it's steel, ask.",
    image:
      "https://images.unsplash.com/photo-1766940973188-598a6bd59ad6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-3",
  },
];

export const GALLERY = [
  {
    id: 1,
    category: "Smokers",
    title: "Twin-chamber smoker trailer",
    titleEs: "Asador de doble cámara con remolque",
    caption:
      "Built and finished in the Firebaugh shop. Dual doors with gauges, expanded-metal shelf, offset firebox and a road-ready single-axle trailer.",
    captionEs:
      "Construido y terminado en el taller de Firebaugh. Doble puerta con termómetros, repisa de metal expandido, caja de fuego lateral y remolque de un eje listo para la carretera.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_firebaugh-metal-shop-1/artifacts/ahgzafo4_IMG_3535.webp",
    real: true,
  },
  {
    id: 12,
    category: "Gates",
    title: "Steel-frame cedar driveway gates",
    titleEs: "Portones de cochera de cedro con marco de acero",
    caption:
      "Three-panel set with welded steel frames and redwood infill — matching side fence, arched top rail and hardware that stays true.",
    captionEs:
      "Juego de tres paneles con marcos de acero soldado y relleno de secuoya — cerca lateral a juego, riel superior arqueado y herrajes que no se desalinean.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_firebaugh-metal-shop-1/artifacts/5ht1cnth_IMG_7933.jpg",
    real: true,
  },
  {
    id: 11,
    category: "Gates",
    title: "Ornamental porch handrails",
    titleEs: "Barandales ornamentales de porche",
    caption:
      "Hand-bent iron rail set for a front porch — curved returns, scrollwork panels and a finish that holds up outside.",
    captionEs:
      "Juego de barandales de hierro doblados a mano para un porche — remates curvos, paneles con volutas y un acabado que aguanta la intemperie.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_firebaugh-metal-shop-1/artifacts/nemnnvka_IMG_4990.webp",
    real: true,
  },
  {
    id: 13,
    category: "Kids Builds",
    title: "Kid-size ranch projects",
    titleEs: "Proyectos a escala para niños",
    caption:
      "Scaled-down flatbed built for a kid's power wheel — welded steel frame and fenders, torched-and-sealed wood deck, expanded-metal headache rack and wired running lights. Pedal-car trailers, mini gates and play-yard panels all get the same treatment.",
    captionEs:
      "Plataforma a escala hecha para un carrito de niño — marco y salpicaderas de acero soldado, piso de madera flameado y sellado, rack de metal expandido y luces instaladas. Remolques para carritos de pedal, portones chicos y paneles de juego llevan el mismo trato.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_firebaugh-metal-shop-1/artifacts/renqccxn_IMG_8841.webp",
    real: true,
  },
  {
    id: 2,
    category: "Smokers",
    title: "Restored tank pit",
    titleEs: "Asador de tanque restaurado",
    caption: "Stripped, patched, re-doored and rolling on a fresh axle.",
    captionEs: "Lijado, parchado, con puertas nuevas y rodando sobre un eje nuevo.",
    image:
      "https://images.unsplash.com/photo-1659116603191-5d380209a23b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: 4,
    category: "Fabrication",
    title: "Shop fabrication",
    titleEs: "Fabricación en el taller",
    caption: "Square, tacked, and welded out hot.",
    captionEs: "A escuadra, punteado y soldado en caliente.",
    image:
      "https://images.unsplash.com/photo-1681399577093-e57cea722a9c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: 5,
    category: "Gates",
    title: "Ranch driveway gate",
    titleEs: "Portón de entrada de rancho",
    caption: "Heavy tube frame, smooth swing, no sag.",
    captionEs: "Marco de tubo pesado, abre suave, sin pandeo.",
    image:
      "https://images.unsplash.com/photo-1645005049035-c35644b627ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: 6,
    category: "Gates",
    title: "Pipe fence & panels",
    titleEs: "Cerca de tubo y paneles",
    caption: "Corral work that livestock can't argue with.",
    captionEs: "Trabajo de corral que el ganado no puede discutir.",
    image:
      "https://images.unsplash.com/photo-1616527206387-29b7a7d37a81?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: 7,
    category: "Repair",
    title: "Implement repair",
    titleEs: "Reparación de implementos",
    caption: "Cracked frame back in service before the next pass.",
    captionEs: "Marco quebrado de vuelta al trabajo antes de la siguiente pasada.",
    image:
      "https://images.unsplash.com/photo-1718470667206-7f8618a1be50?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: 8,
    category: "Repair",
    title: "On-site farm welding",
    titleEs: "Soldadura a domicilio en el rancho",
    caption: "The rig goes where the tractor sits.",
    captionEs: "La soldadora llega donde está el tractor.",
    image:
      "https://images.unsplash.com/photo-1685335686020-e0b487f7f426?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: 9,
    category: "Other",
    title: "Forge & metal art",
    titleEs: "Forja y arte en metal",
    caption: "Signs, brands and one-off pieces.",
    captionEs: "Letreros, fierros de marcar y piezas únicas.",
    image:
      "https://images.unsplash.com/photo-1624382085368-791f6bd1b197?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: 10,
    category: "Other",
    title: "Custom steel piece",
    titleEs: "Pieza de acero a medida",
    caption: "Whatever you sketched on the napkin.",
    captionEs: "Lo que dibujó en la servilleta.",
    image:
      "https://images.unsplash.com/photo-1499815022134-5a333f5a299c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export const GALLERY_FILTERS = ["All", "Fabrication", "Gates", "Smokers", "Repair", "Kids Builds", "Other"];

export const STEPS = [
  {
    n: "01",
    title: "Call or text",
    titleEs: "Llame o textee",
    body: "Tell Wade what broke or what you want built. A photo says more than a paragraph.",
    bodyEs: "Dígale a Wade qué se rompió o qué quiere construir. Una foto dice más que un párrafo.",
  },
  {
    n: "02",
    title: "Get a quote",
    titleEs: "Reciba su cotización",
    body: "Straight number, no runaround. You'll know the price before the sparks fly.",
    bodyEs: "Un número claro, sin vueltas. Sabrá el precio antes de que salten las chispas.",
  },
  {
    n: "03",
    title: "Shop or on-site",
    titleEs: "Taller o a domicilio",
    body: "Bring it to the Firebaugh shop, or the rig comes out to your place.",
    bodyEs: "Tráigalo al taller en Firebaugh, o la soldadora llega a su propiedad.",
  },
  {
    n: "04",
    title: "Built to hold up",
    titleEs: "Hecho para aguantar",
    body: "Welded right the first time so you're not calling anybody about it again.",
    bodyEs: "Soldado bien la primera vez para que no tenga que llamar a nadie otra vez.",
  },
];

export const TOWNS = [
  "Firebaugh",
  "Mendota",
  "Kerman",
  "Los Banos",
  "Dos Palos",
  "Huron",
  "Tranquillity",
  "San Joaquin",
  "Fresno County",
];

export const TESTIMONIALS = [
  { town: "Firebaugh, CA" },
  { town: "Mendota, CA" },
  { town: "Los Banos, CA" },
];
